// extracted by mini-css-extract-plugin
export default {"headerOffset":"SpeakersModule_headerOffset__YZqKW"};